import stylesheet_12 from '../stylesheets/12.js';
import stylesheet_19 from '../stylesheets/19.js';
import stylesheet_18 from '../stylesheets/18.js';
import stylesheet_20 from '../stylesheets/20.js';
import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_15 from '../stylesheets/15.js';
import stylesheet_13 from '../stylesheets/13.js';

export const index = 14;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/international-students/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/14.59aaf198.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/index.1673eb25.js","_app/immutable/chunks/Wrapper.a05beb49.js","_app/immutable/chunks/Hero.89c50aee.js","_app/immutable/chunks/each.15f1f0ab.js","_app/immutable/chunks/ContentCard.e15d56dd.js","_app/immutable/chunks/Roadmap.e8f45c11.js","_app/immutable/chunks/Image.4f8da980.js","_app/immutable/chunks/Button.65ff2d6b.js","_app/immutable/chunks/BookOpenPageVariant.b21da8d2.js","_app/immutable/chunks/CastEducation.24148bb9.js","_app/immutable/chunks/Turbine.2d331ade.js"];
export const stylesheets = ["_app/immutable/assets/14.7ea1ae3f.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.b5a2f49f.css","_app/immutable/assets/Roadmap.0ad4251b.css","_app/immutable/assets/Image.1c236230.css","_app/immutable/assets/Button.4c43b995.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/14.7ea1ae3f.css": stylesheet_12,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_19,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_18,
	"_app/immutable/assets/ContentCard.b5a2f49f.css": stylesheet_20,
	"_app/immutable/assets/Roadmap.0ad4251b.css": stylesheet_17,
	"_app/immutable/assets/Image.1c236230.css": stylesheet_15,
	"_app/immutable/assets/Button.4c43b995.css": stylesheet_13
});
